/**
 * Switch theme values.
 */
import { Components } from "@oui/system/components"
import colors from "../../colors"

const appearances: Components["Switch"]["appearances"] = {
  default: {
    position: "relative",
    "& > input": {
      width: "48px",
      height: "26px",
      opacity: 0,
      "& + span": {
        backgroundColor: `${colors.grays[4]}`
      },
      "&:focus + span": {
        boxShadow: "0 0 0 2px rgb(115, 165, 224, 0.5)"
      },
      "&:not([aria-disabled='true']) + span:hover": {
        cursor: "pointer"
      },
      "&[aria-disabled='true'] + span": {
        backgroundColor: `${colors.grays[1]}`
      },
      "&:checked + span": {
        backgroundColor: `${colors.greens[4]}`
      },
      "&:checked[aria-disabled='true'] + span": {
        backgroundColor: `${colors.greens[0]}`
      },
      "&:checked + span:after": {
        transform: "translateX(22px)"
      }
    }
  }
}

export default { appearances }
